import type DebugSettings from './DebugSettings';

import getInitialDebugSettings from './getInitialDebugSettings';
import readDebugSettingsField from './readDebugSettingsField';

export default function readDebugSettingsFieldOrGetInitialValue<T extends keyof DebugSettings>(settingsFieldKey: T) {
  return readDebugSettingsField(settingsFieldKey) ?? getInitialDebugSettings()[settingsFieldKey];
}
